<!-- 关键输出物 -->
<template>
  <div class="dashboard-editor-container">
    <el-row style="background:#fff;margin-bottom:32px;">
      <el-card class="box-card">
        <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
          <template v-slot:next>
            <el-button icon="el-icon-plus" @click="add">新增</el-button>
          </template>
        </dynamic-search>
        <drag-dialog
          append-to-body
          :show.sync="dialogVisible"
          title="关键输出物"
          :enableDrag="true"
          width="500px"
          @close="cancel"
        >
          <dynamic-form
            :formConfig="formConfig"
            labelWidth="120px"
            v-model="form"
            @submit="submit"
            @cancelForm="cancel"
            ref="pageForm"
          ></dynamic-form>
        </drag-dialog>
        <edit-data-table
          :head="tableHead"
          :data.sync="list"
          :total="total"
          :offset="offset"
          :page="page"
          :loading="loading"
          stripe
          @handlePageChange="dataTablePageChange"
          @handleSizeChange="dataTableSizeChange"
        >
          <template #toolbar="scope">
            <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
            <el-popover :ref="scope.row.id" placement="top" width="180">
              <p>确定删除本条数据吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                <el-button
                  :loading="delLoading"
                  type="primary"
                  size="mini"
                  @click="subDelete(scope.row.id)"
                >确定</el-button>
              </div>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                slot="reference"
              ></el-button>
            </el-popover>
          </template>
        </edit-data-table>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DragDialog from "@/components/DragDialog";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import "@/components/dynamic-form";
import { addOutput, delOutput, editOutput } from "@/api/basic";
import initDict from "@/mixin/initDict";
export default {
  name: "Output",
  components: {
    DynamicSearch,
    DragDialog
  },
  mixins: [DataTableMixin,initDict],
  data() {
    return {
      delLoading: false,
      form: {},
      dialogVisible: false,
      // 表单配置
      formConfig: {
        formItemList: [
          {
            type: "text",
            maxlength: "50",
            showWordLimit: true,
            key: "code",
            label: "输出物代码",
            rules: [
              {
                required: true,
                message: "关键输出物代码生成失败",
                trigger: "blur"
              },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "输出物代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "textarea",
            maxlength: "100",
            showWordLimit: true,
            key: "name",
            label: "输出物名称",
            placeholder: "请输入输出物名称",
            rules: [
              { required: true, message: "输出物名称不能为空", trigger: "blur" }
            ]
          },
          {
            label: "输出物类型",
            key: "type",
            type: "select", // 基础资料对象
            options: [],
            value: "",
            rules: [
              { required: true, message: "请选择输出物类型", trigger: "change" }
            ]
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            validateEvent: true,
            key: "remark",
            label: "备注",
            placeholder: "请输入备注"
          }
        ]
      },
      tableHead: [
        {
          prop: "code",
          label: "输出物代码"
        },
        {
          prop: "name",
          label: "输出物名称",
          query: {
            type: "input"
          }
        },
        {
          prop: "type",
          label: "输出物类型",
        },
        {
          prop: "remark",
          label: "备注"
        }
      ]
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
   // 输出物类型
    this.getDict("keyout_type").then(res => {
       this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'type')].options = res.data;
    });
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/bsKeyOuts";
      const premType = "3,4"; // 权限类型【前端权限】
      const params = { page: this.page, size: this.offset, type: premType };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 新增
    add() {
      this.form = {};
      this.dialogVisible = true;
    },
    // 删除
    subDelete(id) {
      this.delLoading = true;
      delOutput(id)
        .then(res => {
          console.log(res);
          this.dataTableInit();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          });
          this.delLoading = false;
        })
        .catch(() => {
          this.delLoading = false;
        });
    },
    // 修改
    edit(row) {
      console.log(row);
      this.form = row;
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    // 提交
    submit() {
      console.log(this.form);
      if (this.form.id) {
        editOutput(this.form).then(res => {
          console.log(res);
          this.dialogVisible = false;
          this.dataTableInit();
          this.$notify({
            title: "编辑成功",
            type: "success",
            duration: 2500
          });
        });
      } else {
        addOutput(this.form).then(res => {
          console.log(res);
          this.dialogVisible = false;
          this.dataTableInit();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard-editor-container {
  height: 100%;
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;
  .btn {
    border: none;
    padding: 0;
  }
  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
